<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Umowa zlecenie Biuro Obsługi Klienta nr {{ shortNrUmowy() }}</strong>
</p>
<p>
    zawarta pomiędzy:
</p>

<p>
  Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, kapitał zakładowy 6 481 900,00 zł, reprezentowaną przez: 
</p>
<p>
  <strong>{{ zamawiajacy }}</strong>,
</p>
<p>zwaną w dalszej części Umowy „<b>Zleceniodawcą</b>”,</p>
<p>a</p>
<p>Panią/Panem <b>{{ imieNazwisko }}</b>, zam. {{ zamieszkany }}, PESEL: {{ pesel }}</p>
<p>zwaną/ym w dalszej części Umowy „<b>Zleceniobiorcą</b>”,</p>
<p>zwanymi łącznie „<b>Stronami</b>”, a każdy z osobna „<b>Stroną</b>”.</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<ol>
    <li>Przedmiotem niniejszej umowy (dalej „<b>Umowa</b>”), jest określenie warunków współpracy Stron w zakresie świadczenia przez Zleceniobiorcę na rzecz Zleceniodawcy usług obejmujących obsługę klientów Centrum Edukacyjnego ProfiLingua na warunkach i zasadach wskazanych w niniejszej Umowie (dalej: „<b>Usługi</b>”.</li>
    <li>Szczegółowy zakres czynności zleconych do wykonania w ramach Usług wskazany jest w <b>Załączniku nr 6</b> do Umowy.</li>
    <li>Zleceniobiorca oświadcza, że zapoznał się z misją i wizją Zleceniodawcy, przyjętymi u Zleceniodawcy standardami oraz obowiązującymi u Zleceniodawcy regulacjami wewnętrznymi oraz że w razie dokonania ich zmian, zmiany te będą obowiązywały Zleceniobiorcę od dnia powiadomienia go o zmianach. W szczególności, podczas wykonywania zlecenia, Zleceniobiorca zobowiązany jest do dbania o dobro Zleceniodawcy i ochrony jego mienia, w tym do dołożenia najwyższej staranności celem zapewnienia zgodności wszystkich podejmowanych czynności z odpowiednimi politykami, standardami, wytycznymi, kodeksami branżowymi i procedurami (dalej łącznie: „<b>Dokumenty</b>”) obowiązującymi u Zleceniodawcy. Zleceniodawca zobowiązuje Zleceniobiorcę do postępowania zgodnie z zasadami zawartymi w Dokumentach, a ich nieprzestrzeganie może być podstawą do wypowiedzenia Umowy przez Zleceniodawcę ze skutkiem natychmiastowym, z przyczyn leżących po stronie Zleceniobiorcy. Do szczególnych obowiązków Zleceniobiorcy należy przestrzeganie obowiązujących przepisów prawa, w tym w szczególności regulacji ustawy z dnia 6 czerwca 1997 roku – Kodeks karny).</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 2 Zasady świadczenia Usług</strong>
</p>
<ol>
  <li>Zleceniobiorca oświadcza, że dysponuje wiedzą, doświadczeniem oraz uprawnieniami niezbędnymi do należytego wykonania Usług i zobowiązuje się wykonywać je ze szczególną starannością, z uwzględnieniem obowiązujących przepisów prawa, standardów i reguł wykonywania prac objętych niniejszą Umową, dbając o interesy Zleceniodawcy.</li>
  <li>Obowiązki Zleceniobiorcy wynikające z Umowy Zleceniobiorca wykonywać będzie osobiście.</li>
  <li>Zleceniobiorca oświadcza, iż zawarcie i wykonywanie Umowy nie wymaga zgody osób trzecich, w tym instytucji państwowych.</li>
  <li>Strony ustalają, że Usługi będą świadczone przez Zleceniobiorcę w czasie ustalonym w sposób wskazany w ust. 5 poniżej przez Zleceniobiorcę, z uwzględnieniem zapotrzebowania Zleceniodawcy, w placówce określonej w § 1 ust. 1 Umowy lub innym miejscu wskazanym przez Zleceniodawcę.</li>
  <li>Zleceniobiorca na minimum 5 dni przed rozpoczęciem danego miesiąca kalendarzowego (a w pierwszym miesiącu kalendarzowym obowiązywania Umowy na minimum 5 dni przed zaproponowanym przez Zleceniobiorcę pierwszym dniem realizacji Usług w ww. miesiącu) przedstawia Zleceniodawcy drogą mailową (na adres e-mail upoważnionego przedstawiciela Zleceniodawcy, o którym mowa w § 8 ust. 1 Umowy) swoją dostępność, tj. propozycję czasu realizacji Usług, przy czym Zleceniobiorca zobowiązuje się do niezwłocznego informowania Zleceniodawcy o każdorazowej zmianie wskazanej dostępności. W oparciu o przesłaną przez Zleceniobiorcę propozycję czasu realizacji Usług Zleceniodawca przedstawi Zleceniobiorcy <b>harmonogram realizacji Usług</b> obejmujący miesiąc kalendarzowy.</li>
  <li>W każdym czasie Zleceniodawca uprawniony jest do żądania od Zleceniobiorcy przedstawiania szczegółowych informacji na temat świadczonych Usług oraz dowodów ich wykonywania. Żądaniu temu Zleceniobiorca zobowiązany jest sprostać niezwłocznie.</li>
  <li>W celu właściwego wykonywania niniejszej Umowy Zleceniodawca udostępni Zleceniobiorcy stanowisko pracy wyposażone w komputer wraz z oprogramowaniem. Przekazanie narzędzi, o których mowa w zdaniu poprzednim, nastąpi zgodnie z obowiązującymi u Zleceniodawcy zasadami (regulaminem).</li>
  <li>Zleceniobiorca zobowiązuje się zwrócić powierzone mu narzędzia z chwilą rozwiązania Umowy bądź na każde pisemne żądanie Zleceniodawcy. Zleceniobiorca ponosi odpowiedzialność za zniszczenie lub uszkodzenie, udostępnionych w ramach stanowiska pracy, narzędzi, przekraczające zwykłe ich zużycie.</li>
  <li>Zleceniodawca udostępni Zleceniobiorcy system informatyczny niezbędny do świadczenia Usług.</li>
  <li>Zleceniobiorca zobowiązuje się do wykorzystywania systemu informatycznego zgodnie z jego przeznaczeniem oraz w sposób nienaruszający jego integralności, zgodnie z obowiązującymi zasadami. Zleceniobiorca nie jest uprawniony do kopiowania jakichkolwiek danych z udostępnionego systemu informatycznego oraz ich modyfikacji w innym celu niż jest to niezbędne dla wykonywania Umowy.</li>
  <li>W czasie obowiązywania niniejszej Umowy Zleceniobiorca zobowiązuje się do odbywania szkoleń zakreślonych przez Zleceniodawcę, a w razie uzasadnionej niemożliwości, w innym dodatkowym zaproponowanym przez Zleceniodawcę terminie. Nieusprawiedliwione nieodbycie szkolenia w formie (w szczególności webinarium) i w czasie wskazanym przez Zleceniodawcę uprawnia Zleceniodawcę do nałożenia na Zleceniobiorcę kary umownej w wysokości 500 (słownie: pięćset) złotych za każde nieodbyte szkolenie lub do rozwiązania Umowy w trybie natychmiastowym z przyczyn leżących po stronie Zleceniobiorcy.</li>
  <li>Zleceniobiorca oświadcza, że został zapoznany z przepisami BHP, zagrożeniami związanymi ze świadczonymi Usługami. Zleceniobiorca potwierdza ten fakt podpisem na dokumencie: <b>Ogólne Zasady Bhp przy administracyjno-biurowej</b>, która stanowi <b>Załącznik nr 4</b> do Umowy.</li>
  <li>Zleceniobiorca przedstawia Zleceniodawcy zestawienie liczby godzin świadczenia Usług przez Zleceniobiorcę w każdym miesiącu kalendarzowym, w którym Usługi były wykonywane (dalej: „Zestawienie liczby godzin”) za pośrednictwem poczty elektronicznej (na adres e-mail upoważnionego przedstawiciela Zleceniodawcy, o którym mowa w § 8 ust. 1 Umowy) lub wewnętrznego systemu Zamawiającego udostępnionego Zleceniobiorcy, najpóźniej do 5-ego dnia miesiąca następującego po miesiącu kalendarzowym, którego ww. Zestawienie liczby godzin dotyczy. Jeżeli w danym miesiącu obowiązywania Umowy Usługi nie były wykonywane Zleceniobiorca wpisuje „0” w Zestawieniu liczby godzin.</li>
  <li>Zleceniodawca nie później niż w terminie 3 dni od otrzymania zestawienia liczby godzin potwierdza albo odmawia potwierdzenia liczby godzin świadczenia Usług. Informacja o potwierdzeniu albo odmowie potwierdzenia jest przekazywana Zleceniobiorcy za pośrednictwem poczty elektronicznej lub wewnętrznego systemu.</li>
  <li>Zleceniobiorca w terminie 3 dni od daty przekazania przez Zleceniodawcę odmowy potwierdzenia liczby godzin świadczenia Usług w danym miesiącu może wnieść reklamację do Zleceniodawcy, za pośrednictwem poczty elektronicznej lub pisemnie. W terminie 3 dni roboczych od daty otrzymania reklamacji Zleceniodawca informuje Zleceniobiorcę o sposobie rozpoznania reklamacji za pośrednictwem poczty elektronicznej lub w formie pisemnej.</li>
  <li>Strony zgodnie potwierdzają, że czas przygotowania do świadczenia Usług, reklamacji, wykonywania korekt lub poprawek nie jest wliczany do czasu świadczenia Usług.</li>
  <li>Zleceniobiorca oświadcza, że jego stan zdrowia pozwala na świadczenie Usług objętych Umową.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 5px;">
  <strong>§ 3 Wynagrodzenie</strong>
</p>
<ol>
  <li>Zleceniodawca zobowiązuje się do wypłaty, z tytułu właściwego wykonywania Usług w danym miesiącu kalendarzowym wynagrodzenia w wysokości {{ kwota }} ({{ slowniepokaz }}) złotych brutto za każdą godzinę zegarową świadczonych na rzecz Zleceniodawcy Usług.</li>
  <li>Wynagrodzenie, o którym mowa w ust. 1 powyżej, będzie wypłacane na podstawie przygotowanego przez Zleceniobiorcę i zaakceptowanego przez Zleceniodawcę <b>Zestawienia liczby godzin</b> świadczonych Usług w miesiącu, za który dokonywana jest płatność.</li>
  <li>Wynagrodzenie będzie wypłacone przez Zleceniodawcę na wskazany rachunek bankowy Zleceniobiorcy w terminie do <b>15-tego</b> dnia kolejnego miesiąca. Termin wypłaty wynagrodzenia uzależniony jest od daty przekazania przez Zleceniobiorcę i akceptacji przez Zleceniodawcę Zestawienia liczby godzin świadczonych w miesiącu, za który dokonywana jest płatność, przy czym Zestawienie liczby godzin powinno być przekazane <b>nie później niż 13 dni roboczych</b> przed planowaną datą wypłaty wynagrodzenia.</li>
  <li>Za dzień zapłaty uważa się dzień obciążenia rachunku bankowego Zleceniodawcy.</li>
  <li>Strony zgodnie ustalają, że Zleceniobiorca może otrzymać dodatkowe wynagrodzenie w postaci premii, prowizji lub nagrody, na zasadach obowiązujących u Zleceniodawcy. Informacja o zasadach dodatkowego wynagrodzenia będzie przekazywana Zleceniobiorcy przez Zleceniodawcę pisemnie lub za pośrednictwem poczty elektronicznej.</li>
  <li>Zleceniodawca oświadcza, a Zleceniobiorca akceptuje, że warunkiem wypłaty dodatkowego wynagrodzenia jest bezwzględne przestrzeganie przez Zleceniobiorcę zasad compliance obowiązujących u Zleceniodawcy. Jakiekolwiek, chociażby jednorazowe naruszenie tych zasad może skutkować pozbawieniem Zleceniobiorcy dodatkowego wynagrodzenia.</li>
  <li>Wynagrodzenie oraz wynagrodzenie dodatkowe opisane powyżej stanowią całość zobowiązań Zleceniodawcy wobec Zleceniobiorcy z tytułu wykonania Umowy, w czasie jej trwania jak również po jej rozwiązaniu lub wygaśnięciu, w związku z czym Zleceniobiorcy nie przysługuje jakiekolwiek roszczenie o dodatkowe odpłatności związane z wykonywaniem niniejszej Umowy.</li>
  <li>Zleceniobiorca zobowiązuje się do przekazywania Zleceniodawcy wszelkich informacji niezbędnych dla prawidłowego obliczenia i odprowadzenia składek na ubezpieczenia społeczne oraz ubezpieczenie zdrowotne Zleceniobiorcy oraz ich aktualizacji. Zleceniobiorca ponosi odpowiedzialność za nieprawidłowe lub nieterminowe przekazanie informacji, o których mowa w zdaniu poprzednim.</li>
  <li>Zleceniobiorca wyraża zgodę na potrącenie z należnego mu wynagrodzenia kwoty kar umownych przewidzianych Umową.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 4 Prawa autorskie</strong>
</p>
<ol>
  <li>Strony oświadczają, iż Zleceniodawca nabywa autorskie prawa majątkowe do wszystkich utworów w rozumieniu Ustawy z dnia 4 lutego 1994r. o prawie autorskim i prawach pokrewnych(tekst jedn. Dz.U. z 2006 Nr 90 poz. 631 z późn. zm.) [dalej: „<b>Ustawa</b>”], stworzonych przez Zleceniobiorcę w ramach świadczenia Usług, w tym w szczególności utworów powstałych w związku z lub przy okazji wykonywania przez Zleceniobiorcę obowiązków wynikających z Umowy lub innych działań/świadczeń realizowanych przez Zleceniobiorcę, a pozostających w związku przyczynowo-skutkowym ze stosunkiem łączącym strony Umowy [dalej: „<b>Utwory</b>”].</li>
  <li>Nabycie autorskich praw majątkowych do Utworów następuje w momencie ich ustalenia, w ramach wynagrodzenia wskazanego w niniejszej Umowie, otrzymywanego przez Zleceniobiorcę od Zleceniodawcy, i obejmuje terytorium całego świata oraz dokonane zostaje na wszelkich dostępnych polach eksploatacji, polegających w szczególności na wprowadzaniu do pamięci komputera, wprowadzaniu do sieci komputerowych, w szczególności Internetu, nadawaniu za pośrednictwem satelity, sieci komputerowych, eksploatację polegającą na wykorzystywaniu części lub całości Utworu, albo każdego z utworów wchodzących w skład Utworu, do celów reklamowych, niezależnie od formy materiałów reklamowych i ich wielkości, materiałów, z których zostały sporządzone, techniki utrwalania oraz miejsca ekspozycji, oraz w broszurach, ulotkach, wizytówkach reklamowych i katalogach niezależnie od ich liczby, nakładu, techniki sporządzenia i sposobu dystrybucji, wszelką eksploatację części lub całości Utworu, albo każdego z utworów wchodzących w jego skład, polegającą na utrwalaniu i rozpowszechnianiu w ramach ekspozycji reklamowych albo zwielokrotnienia i wprowadzenia do obrotu wszelkiego rodzaju publikacji i innych materiałów reklamowych związanych bezpośrednio lub pośrednio z reklamowanym produktem lub kampanią reklamową oraz eksploatację Utworów na materialnych nośnikach informatycznych (m.in. CD, pendrive, DVD) oraz wszelkich innych dostępnych polach eksploatacji, w szczególności tych wynikających z treści art. 50 Ustawy, tj.:
    <ol type="a">
      <li>w zakresie utrwalania i zwielokrotniania Utworu – wytwarzanie określoną techniką egzemplarzy Utworu, w tym techniką drukarską, reprograficzną, zapisu magnetycznego oraz techniką cyfrową (np. multibooki, audiobooki, e-booki, podręczniki multimedialne);</li>
      <li>w zakresie obrotu oryginałem albo egzemplarzami, na których Utwór utrwalono – wprowadzanie do obrotu, użyczenie lub najem oryginału albo egzemplarzy;</li>
      <li>w zakresie rozpowszechniania Utworu w sposób inny niż określony pod lit. b) powyżej – publiczne wykonanie, wystawienie, wyświetlenie, odtworzenie oraz nadawanie i reemitowanie, a także publiczne udostępnianie Utworu w taki sposób, aby każdy mógł mieć do niego dostęp w miejscu i w czasie przez siebie wybranym (np. Internet, Intranet czy telefonia mobilna),</li>
    </ol>
    wraz z nabyciem prawa zezwalania na wykonywanie zależnych praw autorskich oraz prawa do zezwalania na korzystanie i rozporządzanie opracowaniami Utworu na polach eksploatacji wskazanych powyżej.
  </li>
  <li>W przypadku podjęcia przez Zleceniodawcę decyzji o rozszerzeniu zakresu eksploatacji Utworów o pola niewymienione w ust. 2 powyżej Strony w odrębnej umowie uregulują warunki przeniesienia autorskich praw majątkowych na niewymienione w Umowie pola eksploatacji, które to warunki nie będą odbiegać od warunków przyjętych mocą Umowy. Zleceniodawcy będzie przysługiwało prawo pierwszeństwa w nabyciu praw do eksploatacji Utworów na niewymienionych w Umowie polach eksploatacji.</li>
  <li>Z dniem ustalenia Utworów Zleceniodawca lub osoby przez niego wskazane są upoważnione przez Zleceniobiorcę do wykonywania w jego imieniu przysługujących Zleceniobiorcy autorskich praw osobistych oraz wykonywania praw zależnych do Utworów, w szczególności Zleceniodawca upoważniony jest do publikacji Utworów bez wskazywania autorstwa, a także Zleceniodawca upoważniony jest do decydowania o pierwszym publicznym udostępnieniu Utworu, do nadzoru autorskiego oraz decydowania o nienaruszalności formy i treści Utworu oraz jego rzetelnego wykorzystania (integralności).</li>
  <li>W momencie ustalenia Utworów podmiotem uprawnionym do ich opracowania, w tym także do dokonywania skrótów, podziału na części i łączenia Utworów z innymi utworami lub dziełami niebędącymi utworami w rozumieniu Ustawy, jest Zleceniodawca lub podmiot przez niego upoważniony.</li>
  <li>Zleceniodawcy przysługuje prawo dokonywania wszelkich opracowań Utworów, w tym między innymi dokonywania przeróbek, korekty, zmian i adaptacji całości Utworów lub ich pojedynczych fragmentów, jak również prawo swobodnego używania i/lub korzystania z Utworów oraz ich pojedynczych elementów na terenie kraju oraz za granicą. Uprawnienia wskazane w zdaniu poprzednim przysługują zarówno Zleceniodawcy, jak i podmiotom pozostającym z nim w związkach kapitałowych, personalnych lub gospodarczych.</li>
  <li>W ramach nabytych praw do Utworów Zleceniodawcy przysługuje prawo korzystania z Utworów oraz jego fragmentów w dowolnych celach, w tym w celach promocyjnych, reklamowych i marketingowych, w związku z czym Zleceniodawcy przysługuje prawo sporządzenia dowolnej liczby egzemplarzy okazowych, a także dla realizowanych przez Zleceniodawcę – w tym przez wszystkie jednostki organizacyjne Zleceniodawcy łącznie z Ośrodkiem Rozwoju Kompetencji Edukacyjnych – celów dydaktycznych, w tym na potrzeby organizacji i przeprowadzenia zajęć dydaktycznych łącznie z kursami e-learningowymi, w szczególności w ramach materiałów szkoleniowych przeznaczonych dla uczestników zajęć dydaktycznych i osób je prowadzących.</li>
  <li>Z dniem dostarczenia przez Zleceniobiorcę Utworów na Zleceniodawcę przechodzi własność egzemplarzy, na których utrwalone zostały Utwory.</li>
  <li>Zleceniodawca upoważniony jest do przenoszenia praw do Utworów lub udzielania licencji na rzecz osób trzecich. Całość wpływów z tego tytułu przysługuje Zleceniodawcy.</li>
  <li>Zleceniodawca nie jest zobowiązany do rozpowszechniania żadnego z Utworów.</li>
  <li>Zleceniobiorca oświadcza, że stworzone w związku z wykonywaniem Usług Utwory nie będą naruszały praw osób trzecich oraz zobowiązuje się pokryć wszelkie szkody poniesione przez Zleceniodawcę w przypadku naruszenia takich praw.</li>
  <li>Zleceniobiorca oświadcza, że Utwory będą całkowicie oryginalne i nie będą zawierać żadnych zapożyczeń z innych utworów, które mogłyby spowodować odpowiedzialność Zleceniodawcy z tego tytułu, oraz oświadcza, że jakiekolwiek działanie lub zaniechanie Zleceniobiorcy pozostające w związku z wykonywaniem Usług nie będzie naruszać jakichkolwiek praw osób trzecich.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 5 Klauzula poufności</strong>
  </p>
<ol>
    <li>Zleceniobiorca jest zobowiązany do zachowania w poufności wszelkich informacji i wiedzy, jak również wszelkich dokumentów i projektów dokumentów ujawnionych przez Zleceniodawcę lub do których Zleceniobiorca będzie miał dostęp w związku z realizacją Umowy, zarówno przed jak i po wejściu w życie Umowy, które:
        <ol type="a">
            <li>dotyczą Umowy lub Zleceniodawcy oraz jego działalności, w szczególności wszelkich informacji o charakterze ekonomicznym, handlowym lub organizacyjnym, jak również informacji odnoszących się do jej strategii, personelu i spraw finansowych lub przyszłych planów lub perspektyw, itp. oraz</li>
            <li>które nie zostały podane do publicznej wiadomości, oraz</li>
            <li>które Zleceniobiorca uzyskał lub które staną się mu znane w czasie obowiązywania Umowy, a także przed podpisaniem Umowy, niezależnie od tego, czy informacje te są w formie pisemnej, ustnej czy w jakiejkolwiek innej formie, jak również niezależnie od tego, czy informacje te, wiedza lub dokumenty są wyraźnie oznaczone, jako poufne (zwane dalej: „<b>Informacjami Poufnymi</b>”).</li>
        </ol>
    </li>
    <li>Zobowiązanie, o którym mowa w ust. 1 powyżej, jest wiążące od dnia podpisania Umowy i obowiązuje przez 3 lata po jej wygaśnięciu lub rozwiązaniu.</li>
    <li>Informacje Poufne ujawnione przez Zleceniodawcę w okresie obowiązywania Umowy lub do których Zleceniobiorca będzie miał dostęp w związku z podejmowanymi czynnościami dotyczącymi realizacji Umowy, będą wykorzystywane wyłącznie w zakresie bezpośrednio związanym z realizacją Umowy. Zleceniobiorca nie jest upoważniony do wykorzystywania Informacji Poufnych w celu prowadzenia własnej działalności gospodarczej lub działalności podmiotów trzecich.</li>
    <li>Zleceniodawca i Zleceniobiorca zobowiązują się do należytego zabezpieczenia dokumentów finansowych oraz komputerów zawierających dokumenty i informacje finansowo-księgowe.</li>
    <li>W razie naruszenia przez Zleceniobiorcę ww. zobowiązań, Zleceniobiorca zapłaci Zleceniodawcy karę umowną w wysokości 30 000 zł (słownie: trzydzieści tysięcy) za każde ujawnienie lub wykorzystanie Informacji Poufnych w sposób sprzeczny z postanowieniami niniejszej Umowy w terminie 7 dni od wezwania wystosowanego przez Zleceniodawcę. Zleceniodawca jest uprawniony do dochodzenia naprawienia szkody w wysokości przenoszącej zastrzeżoną karę umowną.</li>
    <li>Zleceniobiorca, który ujawnia Informacje Poufne, stanowiące tajemnicę przedsiębiorstwa Zleceniodawcy innej osobie lub wykorzystuje je we własnej działalności gospodarczej, zgodnie z art. 23 ust. 1. Ustawy z dnia 16 kwietnia 1993 roku o zwalczaniu nieuczciwej konkurencji podlega grzywnie, karze ograniczenia wolności albo pozbawienia wolności do lat 2.</li>
    <li>W okresie trwania Umowy Zleceniobiorca zobowiązuje się nie wykonywać, bez uprzedniej pisemnej zgody Zleceniodawcy, prac bądź usług w zakresie wskazanym w § 1 ust. 2 Umowy na rzecz podmiotów konkurencyjnych w stosunku do Zleceniodawcy, na podstawie jakiegokolwiek stosunku prawnego, pod rygorem obowiązku zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 30 000 zł (słownie: trzydzieści tysięcy) w terminie 7 dni od wezwania wystosowanego przez Zleceniodawcę. Zleceniodawca jest uprawniony do dochodzenia naprawienia szkody w wysokości przenoszącej zastrzeżoną karę umowną.</li>
</ol>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 6 Odpowiedzialność</strong>
</p>
<ol>
  <li>Zleceniobiorca ponosi odpowiedzialność za szkodę wynikłą z niewykonania lub nienależytego wykonania Usług. Zleceniobiorca odpowiada za rzeczywistą, wyrządzoną szkodę oraz za ewentualną utratę korzyści Zleceniodawcy 
i jest zobowiązany do jej naprawienia w pełnej wysokości.</li>
  <li>Zleceniobiorca ponosi pełną odpowiedzialność wobec osób trzecich w przypadku niewykonania lub też nienależytego wykonania Umowy. W przypadku wystąpienia przez osobą trzecią z roszczeniem przeciwko Zleceniodawcy (w tym wytoczenia powództwa lub zgłoszenia się w inny sposób) z tytułu naruszenia praw tej osoby lub osób trzecich lub obowiązujących przepisów prawa, w wyniku niewykonania lub nienależytego wykonania przez Zleceniobiorcę któregokolwiek z zobowiązań określonych w Umowie lub niewypełnienia przez Zleceniobiorcę którejkolwiek z gwarancji udzielonej przez Zleceniobiorcę zgodnie z Umową Zleceniobiorca zobowiązany jest bezzwłocznie wesprzeć Zleceniodawcę w obronie przed takim zarzutem i związanym z nim roszczeniem (w tym poprzez dostarczenie niezbędnego materiału dowodowego przeczącego zasadności danego zarzutu) oraz zobowiązuje się zwolnić Zleceniodawcę z obowiązku zaspokojenia  takiego roszczenia, jeśli będzie to możliwe zgodnie z obowiązującymi przepisami prawa, a także pokryje wszelkie szkody, które Zleceniodawca poniesie w związku z takim roszczeniem, pozwem lub postępowaniem, w tym koszty postępowania i obsługi prawnej oraz równowartości odszkodowania, nałożonych kar lub grzywien, w tym nałożonych na członków zarządu lub pracowników Zleceniodawcy lub koszty wykonania decyzji administracyjnych przez Zleceniodawcę. Powyższe zobowiązania stosuje się odpowiednio w razie wszczęcia wobec Zleceniodawcy postępowania, w tym karnego lub administracyjnego, w wyniku niewykonania lub nienależytego wykonania przez Zleceniobiorcę któregokolwiek z zobowiązań wynikających z Umowy lub niewypełnienia przez Zleceniobiorcę którejkolwiek z gwarancji udzielonej przez Zleceniobiorcę zgodnie z Umową.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 7 Czas trwania i rozwiązanie Umowy</strong>
</p>
<ol>
  <li>Umowa zostaje zawarta na czas określony tj. {{ dataObowiazywaniaUmowy() }}.</li>
  <li>Zleceniodawcy oraz Zleceniobiorcy przysługuje prawo wypowiedzenia Umowy w każdym czasie, bez podania przyczyny, z zachowaniem miesięcznego okresu wypowiedzenia, z zastrzeżeniem, że jeżeli Umowa zawarta jest na okres krótszy niż jeden miesiąc, okres wypowiedzenia wynosi 7 dni.</li>
  <li>Z zastrzeżeniem innych postanowień Umowy, Umowa może być rozwiązana przez Zleceniodawcę ze skutkiem natychmiastowym w przypadku naruszenia istotnych postanowień umowy przez Zleceniobiorcę. W takim wypadku Zleceniodawca obowiązany jest doręczyć Zleceniobiorcy w formie pisemnej jasne i szczegółowe wyjaśnienie powstałych naruszeń i uzasadnić tym samym podstawę rozwiązania Umowy.</li>
  <li>Z chwilą wygaśnięcia Umowy, najpóźniej w dniu wygaśnięcia Umowy, Zleceniobiorca zobowiązany jest zwrócić Zleceniodawcy wszelkie przekazane mu przez Zleceniodawcę na potrzeby realizacji Usług materiały, sprzęt i narzędzia, pod rygorem zapłaty kary umownej w wysokości 1 000 złotych za każdy rozpoczęty dzień opóźnienia lub zwłoki w realizacji ww. zobowiązania.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 8 Klauzula antykorupcyjna</strong>
</p>
  <ol>
    <li>Zleceniobiorca przyjmuje do wiadomości, że jedną z zasad działalności Zleceniodawcy jest przestrzeganie zakazu bezpośredniego lub pośredniego przekazywania jakichkolwiek korzyści majątkowych osobom pełniącym funkcje publiczne lub instytucjom publicznym i państwowym, w celu uzyskania lub utrzymania korzyści handlowych i zobowiązuje się do przestrzegania tej zasady. Na potrzeby Umowy, za osobę pełniąca funkcje publiczną rozumie się w szczególności dyrektora i nauczyciela szkoły publicznej lub prywatno-publicznej, zaś za instytucję publiczną – szkołę publiczną lub prywatno-publiczną.</li>
    <li>Zleceniobiorca przyjmuje do wiadomości, że stosowne przepisy prawa zabraniają, m.in. bezpośredniego lub pośredniego przekazywania korzyści majątkowych lub osobistych funkcjonariuszom publicznym, osobom pełniącym funkcje publiczne oraz innym urzędnikom państwowym, a także partiom politycznym lub ich kandydatom w celu uzyskania lub utrzymania korzyści biznesowych i zobowiązuje się przestrzegać te zasady.</li>
    <li>Zleceniobiorca zobowiązuje się przestrzegać zasad opisanych powyżej, w tym oświadcza, że wynagrodzenie, o którym mowa w § 3 niniejszej Umowy, jest świadczeniem ekwiwalentnym w stosunku do świadczeń wykonanych przez Zleceniobiorcę na podstawie Umowy i nie narusza zasad opisanych w ustępach poprzedzających.</li>
    <li>Zleceniobiorca oświadcza, że nie pozostaje w żadnej relacji służbowej lub osobistej, która mogłaby powodować podejrzenie, że zawarcie Umowy będzie sprzeczne z opisanymi powyżej zasadami. W przypadku podejrzenia zaistnienia takiej relacji, Zleceniobiorca zobowiązuje się niezwłocznie powiadomić o tym fakcie Zleceniodawcę. W takim przypadku Zleceniodawcy przysługuje prawo do natychmiastowego rozwiązania Umowy.</li>
  </ol>
  <br>

  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 9 Standardy ochrony małoletnich</strong>
  </p>
    <p>Zleceniobiorca oświadcza, iż zapoznał się z zapisami dokumentu „Standardy ochrony małoletnich w Tutore Poland Sp. z o.o.” wprowadzonego przez Zleceniodawcę na mocy  ustawy z dnia 13 maja 2024 r. o ochronie małoletnich (Dz.U. 2024 poz. 560) i zobowiązuje się do jej przestrzegania. Naruszenie postanowień regulaminu będzie uznawane za istotne naruszenie obowiązków wynikających z niniejszej umowy i może skutkować jej natychmiastowym rozwiązaniem.</p>
  <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 10 Postanowienia końcowe</strong>
</p>
<ol>
  <li>Zmiana lub uzupełnienie Umowy wymagają zachowania formy pisemnej, pod rygorem nieważności.</li>
  <li>W sprawach nieuregulowanych Umową odpowiednie zastosowanie mają odpowiednie przepisy prawa polskiego w tym przepisy Kodeksu cywilnego.</li>
  <li>W przypadku, gdy którekolwiek z postanowień Umowy okaże się nieważne, bezskuteczne lub niewykonalne, pozostałe postanowienia Umowy będą ważne, skuteczne i wiążące tak jakby nie istniało postanowienie nieważne, bezskuteczne lub niewykonalne, a postanowienia nieważne, bezskuteczne lub niewykonalne zostaną zastąpione postanowieniami, które w najbliższy sposób odpowiadają pierwotnemu zamiarowi Stron w zakresie zgodnym z obowiązującym prawem.</li>
  <li>Jeżeli w czasie trwania Umowy stan prawny, który obowiązywał w czasie zawierania Umowy, zmieni się w ten sposób, że znaczenie, jakie strony nadały poszczególnym postanowieniom Umowy, się zmieni, a z przepisów prawa będzie wynikało, iż nowy stan prawny ma zastosowanie do stosunków prawnych regulowanych Umową, strony zobowiązują się do stosownej zmiany całości lub części Umowy, tak aby przywrócić jej pierwotne znaczenie.</li>
  <li>Wszelkie spory wynikające z niniejszej Umowy lub z nią związane będą rozstrzygane na drodze polubownej, a w przypadku braku porozumienia pomiędzy stronami zostaną poddane rozstrzygnięciu przez sąd powszechny właściwy dla siedziby Zleceniodawcy.</li>
  <li>Umowa sporządzona została w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</li>
  <li>Integralną część Umowy stanowią załączniki:
    <ol class="special">
        <li>Zgoda na wykorzystanie wizerunku</li>
        <li>Klauzula informacyjna RODO</li>
        <li>Upoważnienie do przetwarzania danych osobowych w zbiorze w wersji papierowej i elektronicznej</li>
        <li>Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
        <li>Oświadczenie Zleceniobiorcy</li>
        <li>Szczegółowy zakres czynności</li>
        <li>Kopia pełnomocnictwa</li>
        <li>Kodeks Etyki</li>
    </ol>
  </li>
</ol>
<br>

<div class="cointainer" style="margin-top: 30px; margin-bottom: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{zamawiajacy}}</span><br>
        <span style="margin-left: 0%;"><b>ZLECENIODAWCA</b></span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 0%;"><b>ZLECENIOBIORCA</b></span>
    </div>
</div>

 <div style="margin-top:5px;page-break-before: always;">
   <p><strong>Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
   <p>Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland Sp. z o.o.) zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem umowy zlecenia w celu umieszczenia jej w firmowej stopce mailowej. Wizerunek będzie wykorzystywany wyłącznie na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy.</p>
   <p>Jak również niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o. zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w trakcie wykonywania niniejszej umowy o świadczenie usług przy użyciu telefonów o połączeniu VoIP (Voice over Internet Protocol).</p>
   <p>Niniejsza zgoda obejmuje następujące pola eksploatacji: wykorzystanie, utrwalanie, obróbkę i powielanie wykonanych zdjęć/nagrań, obrót egzemplarzami, na których utrwalono mój wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu wszelkimi dostępnymi technikami i metodami, rozpowszechnianie oraz publikowanie, w materiałach służących działalności Tutore Poland w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.</p>
   <p>Tutore Poland Sp. z o.o. przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku, głosu, wypowiedzi w całości lub w postaci dowolnych fragmentów. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.</p>
</div>

<div style="page-break-before: always;">
  <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
  <p>Klauzule informacyjne z art. 13 RODO</p>
  <p>Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z 04.05.2016, str. 1), dalej „RODO”, informuję, że:</p>
  <p style="margin-bottom: 10px;">Administratorem Pani/Pana danych osobowych jest Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, zwany dalej: „ADO”.</p>
  <p style="margin-bottom: 10px;">Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail kadry@tutore.eu oraz poprzez kontakt z Inspektorem Ochrony Danych na adres e-mail: mlokaj@mlkancelaria.com</p>
  <p>ADO przetwarza dane osobowe w celu:</p>
  <ol type="a">
    <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>zapewnienia kontaktu pomiędzy Stronami (adres  e – mail, nr telefonu) - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji praw i obowiązków wynikających z umowy o świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,</li>
    <li>prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c, f RODO,</li>
    <li>ewidencji przebiegu współpracy (w tym realizacja płatności) - Art. 6 ust. 1 lit. b, c RODO,</li>
    <li>dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,</li>
    <li>realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c RODO,</li>
  </ol>
  <br>
  <p style="margin-bottom: 10px;">Odbiorcami danych osobowych są podmioty, którym ADO powierzył przetwarzanie danych osobowych, w szczególności: dostawcy usług technicznych i organizacyjnych, dostawcy usług księgowych, kadrowych, prawnych i doradczych, banki (realizacja płatności), organy publiczne w ramach realizacji obowiązków związanych z prowadzeniem działalności gospodarczej przez ADO.</p>
  <p style="margin-bottom: 10px;">ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
  <p style="margin-bottom: 10px;">Dane osobowe przechowywane będą przez okres realizacji umowy, a następnie przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa, w tym w szczególności: dochodzenie roszczeń (okres przedawnienia roszczeń), prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5 lat od końca roku kalendarzowego, w którym powstał obowiązek podatkowy).</p>
  <p style="margin-bottom: 10px;">Osoba, której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych, prawo do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</p>
  <p style="margin-bottom: 10px;">Podanie przez Panią/Pana danych osobowych oraz zgoda na ich przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne, ale stanowi warunek konieczny dla nawiązania współpracy i ewentualnego zawarcia umowy w formie pisemnej oraz realizacji praw i obowiązków przez ADO.</p>
  <p style="margin-bottom: 10px;">W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <p style="margin-bottom: 10px;">Zakres danych podlegający przetwarzaniu: imię i nazwisko, adres mailowy, numer telefonu, wizerunek, PESEL.</p>
</div>

<div style="page-break-before: always;">
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p><em><b>Załącznik nr 3.</b></em></p>
    </div>
</div>
</div>
  
  
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Upoważnienie<br>
    do przetwarzania danych osobowych w zbiorze w wersji<br>
    papierowej i elektronicznej
  </strong>
</p>
<p class="p-margin">
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p class="p-margin">
  z dniem podpisania upoważnienia przez obie strony
</p>
<p class="p-margin">
  upoważniam Pana/Panią {{ imieNazwisko }} Zleceniobiorcę Tutore Poland Sp. z o.o.
</p>
<p class="p-margin">
  realizująca umowę zlecenie w Profi
</p>
<p class="p-margin">
  do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
</p>
  <ol>
    <li>w wersji elektronicznej:
      <ul>
        <li>
          zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,
        </li>
        <li>
          zbiór danych osobowych Klientów: dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland– imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail.
        </li>
      </ul>
    </li>
  </ol>
<p class="p-margin">
  w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
</p>
<p class="p-margin">
  Niniejsze upoważnienie nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
</p>
<p>
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
  <br>
  Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
</p>

<div style="page-break-before: always;">
  <p><em><b>Załącznik nr 4</b></em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
  <br>
  <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
  <ul>
    <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
    <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
    <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
    <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
    <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
  </ul>
  <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
  <ul>
    <li>Zaplanować  kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
    <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
    <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
    <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
    <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
    <li>Czynności, które należy wykonywać podczas pracy:</li>
    <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
    <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
    <li>Czynności zabronione:</li>
    <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
    <li>Otwierania osłon podczas pracy urządzeń.</li>
    <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
  </ul>
  <p>Uwagi końcowe:</p>
  <ul>
    <li>
        Przy stałej pracy przy komputerze należy:
        <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
        </ul>
    </li>
  </ul>
  <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
  <div style="margin-top: 40px; font-size: 10px;">
    <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
    <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
  </div>
</div>


</td>
</tr>

</tbody></table>

    <div style="margin-top:5px;page-break-before: always;">
  <p><em><b>Załącznik nr 5. Oświadczenie Zleceniobiorcy</b></em></p>
  <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{data}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{pesel}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoA">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>A. Posiadam na terytorium Rzeczypospolitej Polskiej centrum interesów osobistych lub gospodarczych (ośrodek interesów życiowych*):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoA}}</span></p>
  </td>
  </tr>

  <tr v-if="obywatelstwoB">
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>B. Przebywam na terytorium Rzeczypospolitej Polskiej dłużej niż 183 dni w roku kalendarzowym (podatkowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{obywatelstwoB}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{email}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres zamieszkania</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Adres korespondencyjny</span>
    <br>
    <span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span>
  </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table">
    <span>Urząd Skarbowy</span>
    <br>
    <span>(zgodny z adresem zamieszkania)</span>
    </p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{rencista}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{student}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w przypadku objęcia obowiązkowym ubezpieczeniem emerytalnym i rentowym):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę/umowę zlecenie w innym miejscu niż Tutore Poland Sp. z o.o.: <br> (Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Poland Sp. z o.o. (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore Poland Sp. z o.o. jest wyższe bądź równe krajowej płacy minimalnej.</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>
  
  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieEmerytalne.replace(/\s*\(.*$/, '')}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu niż umowa zlecenie z Tutore Poland Sp. z o.o. (np. zasiłek macierzyński, rodzicielski, urlop wychowawczy, własna pozarolnicza działalność gospodarcza):</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span style="font-size: 12px"><strong>
  Wypełnienie powyższego oświadczenia oznacza zgodę na podanie Tutore Poland Sp. z o.o. numeru telefonu, e-mail i adresu do korespondencji, jak również oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym, oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
  <br/>
  </strong></span></p>
  </td>
  </tr>

  </tbody>
  </table>
  </div>

  <div style="page-break-before: always;">
    <p><strong>Załącznik nr 6.</strong></p>
    <p><b>Szczegółowy zakres czynności zleconych do wykonania, o którym mowa w § 1 ust. 2 Umowy.</b></p>
    <ol>
      <li>W ramach Usług do zadań Zleceniobiorcy należy w szczególności:
        <ol type="a">
          <li>sprzedaż kursów i wykonywanie czynności związanych z funkcjonowaniem Centrum Edukacyjnego ProfiLingua,</li>
          <li>udzielanie rzetelnych informacji dotyczących oferty Centrum Edukacyjnego ProfiLingua w kontakcie bezpośrednim, telefonicznym bądź drogą elektroniczną,</li>
          <li>sprzedaż kursów i aktywne pozyskanie nowych klientów,</li>
          <li>weryfikacja poziomów zaawansowania znajomości języka obcego osób zainteresowanych ofertą Zleceniodawcy na podstawie wyników testu językowego lub rozmowy z lektorem,</li>
          <li>obsługa zapisów (wpisywanie kompleksowych danych do programu ewidencjonującego kursantów, przyjmowanie wpłat, ewidencja sprzedaży, itp.),</li>
          <li>sprzedaż oraz ewidencjonowanie podręczników, pozostałych usług i materiałów edukacyjnych dla kursantów,</li>
          <li>udzielanie rzetelnych informacji lektorom i nauczycielom świadczącym usługi na rzecz Zleceniodawcy,</li>
          <li>wykonywanie czynności związanych z obsługą kursów:
            <ul>
              <li>prowadzenie zapisów i monitorowanie zajęć, w tym zajęć dodatkowych, konsultacji, zajęć video, wywiadówek, lekcji pokazowych dla kursantów i zgodnie z ofertą Centrum Edukacyjnego ProfiLingua,</li>
              <li>monitorowanie wpłat, rezygnacji, obecności kursantów, itp.,</li>
              <li>obsługa windykacji dłużników</li>
            </ul>
          </li>
          <li>wykonywanie czynności administracyjnych związanych z obsługą biurową placówki wskazanej w Umowie</li>
          <li>wykonywanie czynności związanych z obsługą stoiska promocyjnego (za uprzednim mailowym powiadomieniem Zleceniobiorcy),</li>
          <li>wykonywanie czynności związanych z roznoszeniem lub rozwieszaniem materiałów reklamowych (za uprzednim mailowym powiadomieniem Zleceniobiorcy),</li>
          <li>inne czynności wskazane przez Zleceniodawcę.</li>
        </ol>
      </li>
    </ol>
  </div>

  <div style="margin-top: 5px;page-break-before: always;">
    <p><em><b>Załącznik nr 7 Kodeks Etyki</b></em></p>
     Wstęp
     <p>W Grupie Tutore wierzymy, że etyczne i odpowiedzialne działanie to fundament zaufania, zarówno w edukacji, jak i w biznesie. Niniejszy Kodeks Etyki przedstawia wartości i zasady, którymi kierujemy się w naszej codziennej pracy. Kodeks określa standardy postępowania, które wspólnie z naszymi partnerami biznesowymi chcemy budować i rozwijać. Grupa Tutore prowadzi działalność zawodową w sposób profesjonalny oraz odpowiedzialny, zarówno społecznie jak i środowiskowo, z poszanowaniem norm etycznych i przepisów prawa. W celu zapewnienia standardów działalności, dokonujemy wyboru partnerów biznesowych w oparciu o wartości wskazane w Kodeksie Etyki. Grupa wspiera swoich partnerów biznesowych w poszanowaniu Kodeksu, udzielając wszelkich niezbędnych wyjaśnień na każde zapytanie aktualnego lub potencjalnego partnera biznesowego.</p>
     Standardy działalności Grupy
     <p>Nasze działania są oparte na uczciwości, odpowiedzialności i jakości, czyli kluczowych wartościach w branży edukacyjnej. W relacjach z partnerami biznesowymi oraz klientami, Spółki Grupy Tutore kierują się zasadami równego traktowania, transparentności oraz otwartości. Grupa szczególny nacisk kładzie na przestrzeganie przepisów o uczciwej konkurencji, ochronie konsumentów i ochronie danych osobowych. Nieustannie podnosimy jakość świadczonych usług, inwestując w innowacje, rozwój i doskonalenie procesów. Grupa nieustannie rozwija systemy kontroli i audytu, aby zapewnić najwyższe standardy funkcjonowania Spółek.</p>
     Prawa człowieka, prawa dziecka
     <p>Grupa Tutore kładzie nacisk na przestrzeganie fundamentalnych praw i wolności, w szczególności takich jak prawo do życia, zdrowia, zachowania integralności, godności i wolności, prawo do swobodnego wyrażania myśli i słowa, a także prawo do rozwoju. Jako organizacja edukacyjna przykładamy szczególną wagę do standardów ochrony małoletnich oraz potwierdzamy, że Spółki Grupy nie korzystały, nie korzystają i nie zamierzają wykorzystywać pracy dzieci ani pracy przymusowej w swojej działalności.</p>
     Prawa pracownicze
     <p>W Grupie Tutore dbamy o naszych pracowników i współpracowników, tworząc bezpieczne i przyjazne środowisko pracy. Przestrzegamy prawa pracy i stosujemy najwyższe standardy etyczne, zapewniając wszystkim równe szanse rozwoju zawodowego. Spółki zabraniają jakiejkolwiek dyskryminacji oraz wspierają różnorodność, otwartość i kulturę wzajemnego szacunku wśród pracowników i współpracowników. Grupa ustanawia Politykę antymobbingową i zobowiązuje się przedsięwziąć kroki w celu przeciwdziałania i zapobiegania wszelkim formom dyskryminacji i mobbingu.</p>
     Prawa zwierząt i środowisko naturalne
     <p>Działamy w sposób zgodny z przepisami dotyczącymi ochrony środowiska i praw zwierząt. Spółki Grupy zmierzają do zminimalizowania negatywnego wpływu na środowisko naturalne, zdrowie ludzi i zwierząt, podejmując działania ograniczające zużycie energii, emisję gazów cieplarnianych i produkcję odpadów. Nasze decyzje biznesowe uwzględniają troskę o przyszłe pokolenia.</p>
     Ochrona informacji
     <p>Poprzez wdrożenie właściwych polityk i procedur chronimy dane osobowe wszystkich osób i organizacji, z którymi współpracujemy: pracowników, współpracowników, klientów i partnerów. Grupa dba o bezpieczeństwo informacji poufnych, tajemnicy handlowej i know-how, zapewniając pełną zgodność z wymaganiami przepisów prawa krajowego, jak i międzynarodowego. W edukacji zaufanie jest kluczowe, dlatego bezpieczeństwo informacji traktujemy jako priorytet.</p>
     Zasady obowiązujące podmioty posiadające relacje biznesowe z Grupą
     <p>Grupa, jak i Spółki podchodzą do swoich partnerów biznesowych z szacunkiem oraz biznesową uczciwością. Zapraszamy partnerów do współpracy w oparciu o wspólne wartości etyczne oraz poszanowanie prawa krajowego i międzynarodowego. Partnerzy biznesowi Grupy nie mogą być objęci jakimikolwiek sankcjami finansowymi ani gospodarczymi, ani współpracować z podmiotami, których one dotykają. Zastrzegamy możliwość odmowy podjęcia współpracy lub zakończenia współpracy w sytuacjach naruszenia zasad etycznych Grupy.</p>
     Przeciwdziałanie przestępstwom, korupcji, defraudacji i innym nadużyciom
     <p>Grupa Tutore sprzeciwia się popełnianiu jakichkolwiek przestępstw, w szczególności przestępstw korupcji, przekupstwa, defraudacji środków, prania pieniędzy, finansowania terroryzmu oraz fałszerstwa pieniędzy, papierów wartościowych lub dokumentów. Każdy pracownik, współpracownik lub partner biznesowy Grupy, który zauważy lub otrzyma informację o nieprawidłowości, może skorzystać z anonimowej procedury zgłoszeń (ochrona sygnalistów), dostępnej na stronie tutorepoland.liniaetyki.pl.</p>
     Postanowienia końcowe
     <p>Kodeks Etyki ma zastosowanie i jest dostępny dla wszystkich pracowników, współpracowników, osób działających na rzecz/w imieniu Spółek, klientów oraz partnerów biznesowych Spółek Grupy. W ramach Grupy mogą być tworzone dodatkowe dokumenty, mające na celu uszczegółowienie zasad opisanych w niniejszym Kodeksie.</p>
     <p>Wszelkie zgłoszenia oraz zapytania związane z Kodeksem Etyki prosimy przesyłać na adres compliance@tutore.eu.</p>

     <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższy Kodeks Etyki.</p>
    <div style="margin-top: 40px; font-size: 10px;">
      <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
      <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
    </div>
    </div>
  
  </v-container>
</template>

<script>
export default {
  name: 'UmowaBOKProfi',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrumowy: '',
      datapocz: '',
      dataKonca: '',
      wypo: '',
      kwota: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      stawka1: '',
      stawka2: '',
      stawka3: '',
      przedmiot: '',
      ubezpieczenieEmerytalne: '',
      obywatelstwoA: '',
      obywatelstwoB: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrumowy.split('/')
      switch(tab[3]) {
        case 'Promocja':
          shortPosition = 'Prom'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'BOK':
          shortPosition = 'BOK'
          break
        case 'Techniczni - czynności porządkowe':
          shortPosition = 'TCP'
          break
        case 'Techniczni - działalność konserwatora budynków':
          shortPosition = 'TKB'
          break
        case 'Techniczni - ochrona mienia':
          shortPosition = 'TOM'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
    dataObowiazywaniaUmowy() {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'od dnia podpisania umowy przez obie strony do ' + this.dataKonca + ' r.'
      } else {
        return `od ${this.umowaOd} do ${this.dataKonca} r.`
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}

ol.special {
    counter-reset: list;
}

ol.special > li {
    list-style: none;
}

ol.special > li:before {
    content: counter(list) ") ";
    counter-increment: list;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaBOKProfi.vue